import { Theme } from '@mui/material';
import { CSSObject } from 'tss-react';
import { makeStyles } from 'tss-react/mui';

export const WCAGStrandardStyles = makeStyles()((theme: Theme) => ({
  h1: theme.typography.h1 as CSSObject,
  h2: theme.typography.h2 as CSSObject,
  h3: theme.typography.h3 as CSSObject,
  h4: theme.typography.h4 as CSSObject,
  h5: theme.typography.h5 as CSSObject,
  h6: theme.typography.h6 as CSSObject,
  subtitle1: theme.typography.subtitle1 as CSSObject,
  subtitle2: theme.typography.subtitle2 as CSSObject,
}));
